module.exports = __webpack_public_path__ + "static/img/19-1.35a0da9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/19-1.jpg
// module id = gVtL
// module chunks = 0